<template>

    <CustomTable class="shadow-md">
        <template v-slot:header>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Purchaser</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Method</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Credit</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Purchased At</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Expires At</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Price</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
        </template>
        <template v-slot:body>
            <tr class="hover:bg-grey-lighter" v-for="purchase in purchases" v-if="!polling">
                <td class="py-4 px-6 border-b border-grey-light">{{ purchase.purchaser.name }}</td>
                <td class="py-4 px-6 border-b border-grey-light"><span class="badge" v-bind:class="{ 'badge-primary': purchase.method == 'cdn', 'badge-success': purchase.method == 'email', 'badge-dark': purchase.method == 'manual' }">{{ purchase.method | displayMethod }}</span></td>
                <td class="py-4 px-6 border-b border-grey-light">{{ purchase.video.title }}</td>
                <td class="py-4 px-6 border-b border-grey-light">{{ purchase.video.user_credit }}</td>
                <td class="py-4 px-6 border-b border-grey-light">{{ purchase.created_at | displayDateTime }}</td>
                <td class="py-4 px-6 border-b border-grey-light">{{ purchase.expires_at | displayDateTime }}</td>
                <td class="py-4 px-6 border-b border-grey-light">${{ purchase.price }}</td>
                <td class="py-4 px-6 border-b border-grey-light"><button class="btn btn-primary btn-block btn-sm" v-on:click="download(purchase.video_id)">Download</button></td>
            </tr>
            <tr class="bg-grey-lighter text-center" v-if="purchases.length == 0">
                <td class="py-5" colspan="7">
                    <span>Your network does not have any purchases.</span>
                </td>
            </tr>
            <tr class="bg-grey-lighter text-center" v-if="polling">
                <td class="py-5" colspan="7">
                    <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
                </td>
            </tr>
        </template>
    </CustomTable>
			
</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'HelloWorld',
		data () {
			return {
                purchases: {},
                polling: true,
			}
        },
        mounted() {
            this.getPurchasedVideos();
        },
        components: {
            CustomTable
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getPurchasedVideos() {
                this.$http.get(Config.apiPath + "/api/v2/media/purchases", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'purchases', response.data)
                    this.$set(this, 'polling', false)
                });
            },
            download(id) {
                var self = this;
                this.$http.get(Config.apiPath + "/api/v2/media/purchases/download/" + id, this.getAuthorizationHeader())
                    .then((response) => {
                        if(response.data !== 400) {
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = response.data;
                            link.click();
                            document.body.removeChild(link);
                        } else {
                            self.$swal(
                                'Uh oh!',
                                'There has been an issue. It looks like you don\'t own this video. If this is a mistake, please open a support ticket or contact Brett Adair.',
                                'error'
                            )
                        }
                    });
            }
        },
        filters: {
            displayMethod: function(data) {
                if(data == 'email') {
                    return "Email"
                } else if(data == 'cdn') {
                    return "CDN"
                } else if(data == 'manual') {
                    return "Manual"
                }
            },
            displayDateTime: function(data) {
                return moment.utc(data).local().format('MM/DD/YY h:mm a');
            }
        }
	}
</script>

<style scoped>

</style>
